import CreativeGridView from '@/Enums/CampaignManagement/CreativeGridView.enum';
import { IDV360TicketsCreative } from '@/Interfaces/DV360Tickets/Creative.interface';
import { IDV360TicketsLineItemForm } from '@/Interfaces/DV360Tickets/LineItem.interface';
import { getColumns } from '@/pages/CampaignManagement/CreateCampaign/DV360TicketsLineItemForm/Creatives/Table/columns';
import CreativesTable from '@/pages/CampaignManagement/CreateCampaign/LineItemForm/Creatives/Table';
import { useFormContext } from 'react-hook-form';

const CreativeInfo = () => {
  const { getValues } = useFormContext<IDV360TicketsLineItemForm>();

  const associatedCreatives: IDV360TicketsCreative[] = getValues('creatives');

  const creativeIds = associatedCreatives.map(creative => creative.id);

  const rows = associatedCreatives.map((creative, index) => ({
    ...creative,
    creativeIndex: index,
  }));

  const columns = getColumns({ creativeIds, view: CreativeGridView.LineItemSummary });

  return (
    <div>
      <p>Associated Creatives</p>
      <div className='my-1'>
        <CreativesTable
          tableData={rows}
          columns={columns}
          checkboxSelection={false}
          rowSelectionModel={[]}
          handleRowSelectionModelChange={() => null}
          withoutPagination
          setTableFilters={() => null}
        />
      </div>
    </div>
  );
};

export default CreativeInfo;
